export const aciFrigobar = {
    iconName: 'frigobar',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M18.734 2H5.932A.932.932 0 005 2.932v16.802c0 .515.417.933.932.933h12.802a.932.932 0 00.933-.933V2.932A.932.932 0 0018.734 2zM7.667 20.667V22M17 20.667V22M7.667 8.667v4',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
